// données.js
export const departementsEtRegions = [
  {
    code: "01",
    departement: "Ain",
    region: "Auvergne-Rhône-Alpes",
    pays: "France",
  },
  {
    code: "02",
    departement: "Aisne",
    region: "Hauts-de-France",
    pays: "France",
  },
  {
    code: "03",
    departement: "Allier",
    region: "Auvergne-Rhône-Alpes",
    pays: "France",
  },
  {
    code: "04",
    departement: "Alpes-de-Haute-Provence",
    region: "Provence-Alpes-Côte d'Azur",
    pays: "France",
  },
  {
    code: "05",
    departement: "Hautes-Alpes",
    region: "Provence-Alpes-Côte d'Azur",
    pays: "France",
  },
  {
    code: "06",
    departement: "Alpes-Maritimes",
    region: "Provence-Alpes-Côte d'Azur",
  },
  {
    code: "07",
    departement: "Ardèche",
    region: "Auvergne-Rhône-Alpes",
    pays: "France",
  },
  { code: "08", departement: "Ardennes", region: "Grand Est", pays: "France" },
  { code: "09", departement: "Ariège", region: "Occitanie", pays: "France" },
  { code: "10", departement: "Aube", region: "Grand Est", pays: "France" },
  { code: "11", departement: "Aude", region: "Occitanie", pays: "France" },
  { code: "12", departement: "Aveyron", region: "Occitanie", pays: "France" },
  {
    code: "13",
    departement: "Bouches-du-Rhône",
    region: "Provence-Alpes-Côte d'Azur",
    pays: "France",
  },
  { code: "14", departement: "Calvados", region: "Normandie", pays: "France" },
  {
    code: "15",
    departement: "Cantal",
    region: "Auvergne-Rhône-Alpes",
    pays: "France",
  },
  {
    code: "16",
    departement: "Charente",
    region: "Nouvelle-Aquitaine",
    pays: "France",
  },
  {
    code: "17",
    departement: "Charente-Maritime",
    region: "Nouvelle-Aquitaine",
    pays: "France",
  },
  {
    code: "18",
    departement: "Cher",
    region: "Centre-Val de Loire",
    pays: "France",
  },
  {
    code: "19",
    departement: "Corrèze",
    region: "Nouvelle-Aquitaine",
    pays: "France",
  },
  { code: "20", departement: "Corse", region: "Corse", pays: "France" },
  {
    code: "21",
    departement: "Côte-d'Or",
    region: "Bourgogne-Franche-Comté",
    pays: "France",
  },
  {
    code: "22",
    departement: "Côtes-d'Armor",
    region: "Bretagne",
    pays: "France",
  },
  {
    code: "23",
    departement: "Creuse",
    region: "Nouvelle-Aquitaine",
    pays: "France",
  },
  {
    code: "24",
    departement: "Dordogne",
    region: "Nouvelle-Aquitaine",
    pays: "France",
  },
  {
    code: "25",
    departement: "Doubs",
    region: "Bourgogne-Franche-Comté",
    pays: "France",
  },
  {
    code: "26",
    departement: "Drôme",
    region: "Auvergne-Rhône-Alpes",
    pays: "France",
  },
  { code: "27", departement: "Eure", region: "Normandie", pays: "France" },
  {
    code: "28",
    departement: "Eure-et-Loir",
    region: "Centre-Val de Loire",
    pays: "France",
  },
  { code: "29", departement: "Finistère", region: "Bretagne", pays: "France" },
  { code: "2A", departement: "Corse-du-Sud", region: "Corse", pays: "France" },
  { code: "2B", departement: "Haute-Corse", region: "Corse", pays: "France" },
  { code: "30", departement: "Gard", region: "Occitanie", pays: "France" },
  {
    code: "31",
    departement: "Haute-Garonne",
    region: "Occitanie",
    pays: "France",
  },
  { code: "32", departement: "Gers", region: "Occitanie", pays: "France" },
  {
    code: "33",
    departement: "Gironde",
    region: "Nouvelle-Aquitaine",
    pays: "France",
  },
  { code: "34", departement: "Hérault", region: "Occitanie", pays: "France" },
  {
    code: "35",
    departement: "Ille-et-Vilaine",
    region: "Bretagne",
    pays: "France",
  },
  {
    code: "36",
    departement: "Indre",
    region: "Centre-Val de Loire",
    pays: "France",
  },
  {
    code: "37",
    departement: "Indre-et-Loire",
    region: "Centre-Val de Loire",
    pays: "France",
  },
  {
    code: "38",
    departement: "Isère",
    region: "Auvergne-Rhône-Alpes",
    pays: "France",
  },
  {
    code: "39",
    departement: "Jura",
    region: "Bourgogne-Franche-Comté",
    pays: "France",
  },
  {
    code: "40",
    departement: "Landes",
    region: "Nouvelle-Aquitaine",
    pays: "France",
  },
  {
    code: "41",
    departement: "Loir-et-Cher",
    region: "Centre-Val de Loire",
    pays: "France",
  },
  {
    code: "42",
    departement: "Loire",
    region: "Auvergne-Rhône-Alpes",
    pays: "France",
  },
  {
    code: "43",
    departement: "Haute-Loire",
    region: "Auvergne-Rhône-Alpes",
    pays: "France",
  },
  {
    code: "44",
    departement: "Loire-Atlantique",
    region: "Pays de la Loire",
    pays: "France",
  },
  {
    code: "45",
    departement: "Loiret",
    region: "Centre-Val de Loire",
    pays: "France",
  },
  { code: "46", departement: "Lot", region: "Occitanie", pays: "France" },
  {
    code: "47",
    departement: "Lot-et-Garonne",
    region: "Nouvelle-Aquitaine",
    pays: "France",
  },
  { code: "48", departement: "Lozère", region: "Occitanie", pays: "France" },
  {
    code: "49",
    departement: "Maine-et-Loire",
    region: "Pays de la Loire",
    pays: "France",
  },
  { code: "50", departement: "Manche", region: "Normandie", pays: "France" },
  { code: "51", departement: "Marne", region: "Grand Est", pays: "France" },
  {
    code: "52",
    departement: "Haute-Marne",
    region: "Grand Est",
    pays: "France",
  },
  {
    code: "53",
    departement: "Mayenne",
    region: "Pays de la Loire",
    pays: "France",
  },
  {
    code: "54",
    departement: "Meurthe-et-Moselle",
    region: "Grand Est",
    pays: "France",
  },
  { code: "55", departement: "Meuse", region: "Grand Est", pays: "France" },
  { code: "56", departement: "Morbihan", region: "Bretagne", pays: "France" },
  { code: "57", departement: "Moselle", region: "Grand Est", pays: "France" },
  {
    code: "58",
    departement: "Nièvre",
    region: "Bourgogne-Franche-Comté",
    pays: "France",
  },
  {
    code: "59",
    departement: "Nord",
    region: "Hauts-de-France",
    pays: "France",
  },
  {
    code: "60",
    departement: "Oise",
    region: "Hauts-de-France",
    pays: "France",
  },
  { code: "61", departement: "Orne", region: "Normandie", pays: "France" },
  {
    code: "62",
    departement: "Pas-de-Calais",
    region: "Hauts-de-France",
    pays: "France",
  },
  {
    code: "63",
    departement: "Puy-de-Dôme",
    region: "Auvergne-Rhône-Alpes",
    pays: "France",
  },
  {
    code: "64",
    departement: "Pyrénées-Atlantiques",
    region: "Nouvelle-Aquitaine",
    pays: "France",
  },
  {
    code: "65",
    departement: "Hautes-Pyrénées",
    region: "Occitanie",
    pays: "France",
  },
  {
    code: "66",
    departement: "Pyrénées-Orientales",
    region: "Occitanie",
    pays: "France",
  },
  { code: "67", departement: "Bas-Rhin", region: "Grand Est", pays: "France" },
  { code: "68", departement: "Haut-Rhin", region: "Grand Est", pays: "France" },
  {
    code: "69",
    departement: "Rhône",
    region: "Auvergne-Rhône-Alpes",
    pays: "France",
  },
  {
    code: "70",
    departement: "Haute-Saône",
    region: "Bourgogne-Franche-Comté",
    pays: "France",
  },
  {
    code: "71",
    departement: "Saône-et-Loire",
    region: "Bourgogne-Franche-Comté",
    pays: "France",
  },
  {
    code: "72",
    departement: "Sarthe",
    region: "Pays de la Loire",
    pays: "France",
  },
  {
    code: "73",
    departement: "Savoie",
    region: "Auvergne-Rhône-Alpes",
    pays: "France",
  },
  {
    code: "74",
    departement: "Haute-Savoie",
    region: "Auvergne-Rhône-Alpes",
    pays: "France",
  },
  { code: "75", departement: "Paris", region: "Île-de-France", pays: "France" },
  {
    code: "76",
    departement: "Seine-Maritime",
    region: "Normandie",
    pays: "France",
  },
  {
    code: "77",
    departement: "Seine-et-Marne",
    region: "Île-de-France",
    pays: "France",
  },
  {
    code: "78",
    departement: "Yvelines",
    region: "Île-de-France",
    pays: "France",
  },
  {
    code: "79",
    departement: "Deux-Sèvres",
    region: "Nouvelle-Aquitaine",
    pays: "France",
  },
  {
    code: "80",
    departement: "Somme",
    region: "Hauts-de-France",
    pays: "France",
  },
  { code: "81", departement: "Tarn", region: "Occitanie", pays: "France" },
  {
    code: "82",
    departement: "Tarn-et-Garonne",
    region: "Occitanie",
    pays: "France",
  },
  {
    code: "83",
    departement: "Var",
    region: "Provence-Alpes-Côte d'Azur",
    pays: "France",
  },
  {
    code: "84",
    departement: "Vaucluse",
    region: "Provence-Alpes-Côte d'Azur",
    pays: "France",
  },
  {
    code: "85",
    departement: "Vendée",
    region: "Pays de la Loire",
    pays: "France",
  },
  {
    code: "86",
    departement: "Vienne",
    region: "Nouvelle-Aquitaine",
    pays: "France",
  },
  {
    code: "87",
    departement: "Haute-Vienne",
    region: "Nouvelle-Aquitaine",
    pays: "France",
  },
  { code: "88", departement: "Vosges", region: "Grand Est", pays: "France" },
  {
    code: "89",
    departement: "Yonne",
    region: "Bourgogne-Franche-Comté",
    pays: "France",
  },
  {
    code: "90",
    departement: "Territoire de Belfort",
    region: "Bourgogne-Franche-Comté",
    pays: "France",
  },
  {
    code: "91",
    departement: "Essonne",
    region: "Île-de-France",
    pays: "France",
  },
  {
    code: "92",
    departement: "Hauts-de-Seine",
    region: "Île-de-France",
    pays: "France",
  },
  {
    code: "93",
    departement: "Seine-Saint-Denis",
    region: "Île-de-France",
    pays: "France",
  },
  {
    code: "94",
    departement: "Val-de-Marne",
    region: "Île-de-France",
    pays: "France",
  },
  {
    code: "95",
    departement: "Val-d'Oise",
    region: "Île-de-France",
    pays: "France",
  },
  {
    code: "971",
    departement: "Guadeloupe",
    region: "Guadeloupe",
    pays: "France",
  },
  {
    code: "972",
    departement: "Martinique",
    region: "Martinique",
    pays: "France",
  },
  { code: "973", departement: "Guyane", region: "Guyane", pays: "France" },
  {
    code: "974",
    departement: "La Réunion",
    region: "La Réunion",
    pays: "France",
  },
  { code: "976", departement: "Mayotte", region: "Mayotte", pays: "France" },

  // Belgique (Provinces)
  {
    code: "BRU",
    departement: "Bruxelles-Capitale",
    region: "Bruxelles",
    pays: "Belgique",
  },
  {
    code: "WBR",
    departement: "Brabant Wallon",
    region: "Wallonie",
    pays: "Belgique",
  },
  {
    code: "VBR",
    departement: "Brabant Flamand",
    region: "Flandre",
    pays: "Belgique",
  },
  { code: "HAI", departement: "Hainaut", region: "Wallonie", pays: "Belgique" },
  { code: "LIE", departement: "Liège", region: "Wallonie", pays: "Belgique" },
  {
    code: "LUX",
    departement: "Luxembourg",
    region: "Wallonie",
    pays: "Belgique",
  },
  { code: "NAM", departement: "Namur", region: "Wallonie", pays: "Belgique" },
  {
    code: "FAN",
    departement: "Flandre-Orientale",
    region: "Flandre",
    pays: "Belgique",
  },
  {
    code: "FLN",
    departement: "Flandre-Occidentale",
    region: "Flandre",
    pays: "Belgique",
  },
  { code: "LIM", departement: "Limbourg", region: "Flandre", pays: "Belgique" },

  // Luxembourg
  {
    code: "L",
    departement: "Luxembourg",
    region: "Luxembourg",
    pays: "Luxembourg",
  },

  // Suisse (Cantons)
  { code: "AG", departement: "Argovie", region: "Suisse", pays: "Suisse" },
  { code: "AI", departement: "Appenzell Rhodes-Intérieures", region: "Suisse", pays: "Suisse" },
  { code: "AR", departement: "Appenzell Rhodes-Extérieures", region: "Suisse", pays: "Suisse" },
  { code: "BE", departement: "Berne", region: "Suisse", pays: "Suisse" },
  { code: "BL", departement: "Bâle-Campagne", region: "Suisse", pays: "Suisse" },
  { code: "BS", departement: "Bâle-Ville", region: "Suisse", pays: "Suisse" },
  { code: "FR", departement: "Fribourg", region: "Suisse", pays: "Suisse" },
  { code: "GE", departement: "Genève", region: "Suisse", pays: "Suisse" },
  { code: "GL", departement: "Glaris", region: "Suisse", pays: "Suisse" },
  { code: "GR", departement: "Grisons", region: "Suisse", pays: "Suisse" },
  { code: "JU", departement: "Jura", region: "Suisse", pays: "Suisse" },
  { code: "LU", departement: "Lucerne", region: "Suisse", pays: "Suisse" },
  { code: "NE", departement: "Neuchâtel", region: "Suisse", pays: "Suisse" },
  { code: "NW", departement: "Nidwald", region: "Suisse", pays: "Suisse" },
  { code: "OW", departement: "Obwald", region: "Suisse", pays: "Suisse" },
  { code: "SG", departement: "Saint-Gall", region: "Suisse", pays: "Suisse" },
  { code: "SH", departement: "Schaffhouse", region: "Suisse", pays: "Suisse" },
  { code: "SO", departement: "Soleure", region: "Suisse", pays: "Suisse" },
  { code: "SZ", departement: "Schwytz", region: "Suisse", pays: "Suisse" },
  { code: "TG", departement: "Thurgovie", region: "Suisse", pays: "Suisse" },
  { code: "TI", departement: "Tessin", region: "Suisse", pays: "Suisse" },
  { code: "UR", departement: "Uri", region: "Suisse", pays: "Suisse" },
  { code: "VD", departement: "Vaud", region: "Suisse", pays: "Suisse" },
  { code: "VS", departement: "Valais", region: "Suisse", pays: "Suisse" },
  { code: "ZG", departement: "Zoug", region: "Suisse", pays: "Suisse" },
  { code: "ZH", departement: "Zurich", region: "Suisse", pays: "Suisse" },
  

  // Ajoutez tous les autres départements ici...
];
